import * as React from 'react';

export default class Router {
  static shared = new Router();
  pathname: string;
  app?: React.Component;
  didFoundRoute: boolean;

  constructor() {
    this.pathname = location.pathname;
  }

  attach = (app: React.Component) => {
    this.app = app;
    window.addEventListener('popstate', this.locationChange);
  };

  detach = () => {
    this.app = undefined;
    window.removeEventListener('popstate', this.locationChange);
  };

  locationChange = (event: PopStateEvent) => {
    console.log('popstate', this.pathname, location.pathname)
    if (this.pathname !== location.pathname) {
      this.pathname = location.pathname;
      if (this.app) {
        this.app.forceUpdate();
      }
    }
  };

  onRenderStart = () => {
    this.didFoundRoute = false;
  }

  navigateTo = (url: string) => {
    history.pushState({}, undefined, url);
    window.dispatchEvent(new Event('popstate'));
  }
}



// WEBPACK FOOTER //
// ./src/router/Router.ts